import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSeo } from '../hooks/useSeo';

export default function NotFoundPage() {
  const { t } = useTranslation();

  useSeo({
    title: t('seo.notFound.title'),
    description: t('notFound.text'),
    path: '/404',
    noindex: true,
  });

  return (
    <section className="section not-found in-view">
      <div className="section__container not-found__inner">
        <h2 className="section__title">{t('notFound.title')}</h2>
        <p className="not-found__text">{t('notFound.text')}</p>
        <Link to="/" className="btn btn--outline">{t('notFound.backToHome')}</Link>
      </div>
    </section>
  );
}
